const STOREFRONT_TOKEN = "eb11a16cfbfdd9fe0e1c6c0109cbbd6c";

const PRODUCTS_PER_PAGE = 12;
let currentPage = 1;
let allProducts = [];
let filteredProducts = [];
let activeMinPrice = 0;
let activeMaxPrice = null;

const query = `{
  products(first: 100, query: "product_type:Diwali") {
    edges {
      node {
        id
        title
        handle
        availableForSale
        featuredImage {
          url
          width
          height
        }
        images(first: 2) {
          edges {
            node {
              url
              width
              height
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
              }
            }
          }
        }
      }
    }
  }
}`;

fetch("/api/2025-10/graphql.json", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
  },
  body: JSON.stringify({ query })
})
  .then(res => res.json())
  .then(({ data }) => {
    allProducts = data.products.edges;

    setActivePriceRangeFromDOM();
    applyPriceFilter();

    renderProducts();

    const viewMoreBtn = document.querySelector(".view-more-btn");
    if (viewMoreBtn) {
      viewMoreBtn.addEventListener("click", () => {
        currentPage++;
        renderProducts();
      });
    }

    document.querySelectorAll(".price-tab-btn").forEach(tab => {
      tab.addEventListener("click", () => {
        if (tab.classList.contains("active")) return;

        document
          .querySelectorAll(".price-tab-btn")
          .forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        setActivePriceRangeFromDOM();
        currentPage = 1;
        applyPriceFilter();
        renderProducts();
      });
    });
  })
  .catch(err => console.error("Error fetching products:", err));

function setActivePriceRangeFromDOM() {
  const activeTab = document.querySelector(".price-tab-btn.active");
  activeMinPrice = activeTab && activeTab.dataset.minPrice !== undefined
    ? parseFloat(activeTab.dataset.minPrice)
    : 0;
  activeMaxPrice = activeTab && activeTab.dataset.maxPrice !== undefined
    ? parseFloat(activeTab.dataset.maxPrice)
    : null;
}

function getProductPrice(product) {
  const variant = product.variants.edges[0]?.node;
  return parseFloat(variant?.price?.amount || "0");
}

function applyPriceFilter() {
  filteredProducts = allProducts.filter(({ node }) => {
    const price = getProductPrice(node);
    const aboveMin = price >= (activeMinPrice || 0);
    const belowMax = activeMaxPrice === null || price <= activeMaxPrice;
    return aboveMin && belowMax;
  });
  filteredProducts.sort((a, b) => getProductPrice(b.node) - getProductPrice(a.node));
}

function formatPrice(amount) {
  return `₹${parseFloat(amount || "0").toFixed(2)}`;
}

function buildCard(template, product) {
  const variant = product.variants.edges[0]?.node;
  const price = variant?.price?.amount || "0.00";
  const compareAt = variant?.compareAtPrice?.amount;
  const isSoldOut = !product.availableForSale;
  const isOnSale = !!compareAt && parseFloat(compareAt) > parseFloat(price);

  let discountPercent = 0;
  if (isOnSale) {
    discountPercent = Math.round(
      ((parseFloat(compareAt) - parseFloat(price)) / parseFloat(compareAt)) * 100
    );
  }

  const primaryImg = product.featuredImage;
  const secondaryImg = product.images?.edges?.[1]?.node || null;
  const productUrl = `/products/${product.handle}`;

  const node = template.content.firstElementChild.cloneNode(true);

  // Images
  const primaryImgEl = node.querySelector('[data-slot="primary-image"]');
  if (primaryImg?.url) {
    primaryImgEl.src = primaryImg.url;
    primaryImgEl.srcset = `${primaryImg.url} 1x`;
    primaryImgEl.width = primaryImg.width || 633;
    primaryImgEl.height = primaryImg.height || 633;
    primaryImgEl.alt = product.title;
  }

  const secondaryImgEl = node.querySelector('[data-slot="secondary-image"]');
  if (secondaryImg?.url) {
    secondaryImgEl.src = secondaryImg.url;
    secondaryImgEl.srcset = `${secondaryImg.url} 1x`;
    secondaryImgEl.width = secondaryImg.width || 633;
    secondaryImgEl.height = secondaryImg.height || 633;
    secondaryImgEl.hidden = false;
  }

  // Titles / links
  ["title-link-1", "title-link-2"].forEach(slot => {
    const el = node.querySelector(`[data-slot="${slot}"]`);
    el.href = productUrl;
    el.textContent = product.title;
  });
  node.querySelector('[data-slot="details-link"]').href = productUrl;

  // Top badge (sold out / discount)
  const badgeTop = node.querySelector('[data-slot="badge-top"]');
  const badgeTopText = node.querySelector('[data-slot="badge-top-text"]');
  if (isSoldOut) {
    badgeTop.hidden = false;
    badgeTopText.textContent = "Sold out";
    badgeTopText.classList.add("color-scheme-3");
  } else if (discountPercent > 0) {
    badgeTop.hidden = false;
    badgeTopText.textContent = `${discountPercent}% OFF`;
    badgeTopText.classList.add("color-scheme-4");
  }

  // Sale badge (bottom, only when on sale and not sold out)
  if (!isSoldOut && discountPercent > 0) {
    node.querySelector('[data-slot="badge-sale"]').hidden = false;
  }

  // Price
  const priceWrap = node.querySelector('[data-slot="price-wrap"]');
  if (isOnSale) priceWrap.classList.add("price--on-sale");

  node.querySelector('[data-slot="price-regular"]').textContent = formatPrice(price);
  node.querySelector('[data-slot="price-sale"]').textContent = formatPrice(price);
  node.querySelector('[data-slot="price-compare"]').textContent = isOnSale
    ? formatPrice(compareAt)
    : "";

  return node;
}

function renderProducts() {
  const grid = document.querySelector("#product-grid");
  const viewMoreWrap = document.querySelector(".view-more-wrap");
  const template = document.querySelector("#diwali-product-card-template");

  if (!grid || !template) return;

  grid.innerHTML = "";

  const visibleProducts = filteredProducts.slice(0, currentPage * PRODUCTS_PER_PAGE);

  if (visibleProducts.length === 0) {
    grid.innerHTML = `<li class="price-tab-empty">No products found in this price range.</li>`;
  } else {
    visibleProducts.forEach(({ node: product }) => {
      grid.appendChild(buildCard(template, product));
    });
  }

  if (viewMoreWrap) {
    viewMoreWrap.style.display =
      currentPage * PRODUCTS_PER_PAGE >= filteredProducts.length ? "none" : "block";
  }
}